import styled from "styled-components";

interface IContactsListItemLoaderPlaceholder {
  inListContacts?: boolean;
}

const UserListItemLoader: React.FC<IContactsListItemLoaderPlaceholder> = (props) => {
  const { inListContacts } = props;
  return (
    <Wrapper>
      <div className="sk-container">
        <div className="d-flex justify-content-between">
          <div className="profile-detail d-flex justify-content-start">
            <span
              className="skeleton-box checkbox"
              style={{ width: "15px", height: "15px", marginRight: "15px" }}
            ></span>
            <span
              className="skeleton-box profile"
              style={{ width: "54px", height: "54px", marginRight: "15px" }}
            ></span>
            <div style={{ width: "225px" }}>
              <span className="skeleton-box mt-2 redius-1" style={{ width: "100%", height: "15px" }}></span>
              <span className="skeleton-box mt-1 redius-1" style={{ width: "80%", height: "10px" }}></span>
            </div>
          </div>
          <div className={`loader-2 ${inListContacts ? "list-loader" : ""}`}>
            <span className="skeleton-box width mt-2 redius-1"></span>
            <span className="skeleton-box width mt-2 redius-1"></span>
            <span className="skeleton-box width mt-2 redius-1"></span>
          </div>
          <div className="loader-3 d-flex align-items-start">
            <span className="skeleton-box loader-3-width mt-2 redius-1"></span>
            <span className="skeleton-box ellipsis-loader mt-2 redius-1"></span>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default UserListItemLoader;

const Wrapper = styled.div`
  overflow: hidden;
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 100%;
    padding: 12px;
    margin: 0;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: #fff;
    .loader-2 {
      display: flex;
      justify-content: space-between;
      width: 585px;
      margin-left: -275px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 435px;
        margin-left: -145px;
      }
      &.list-loader {
        width: 555px;
        margin-left: -295px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 415px;
          margin-left: -165px;
        }
      }
    }
    .loader-3 {
      margin-right: 100px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-right: 75px;
      }
      .loader-3-width {
        width: 80px;
        height: 15px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 60px;
        }
      }
    }
    .profile-detail {
      width: 380px;
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.ellipsis-loader {
        width: 10px;
        height: 30px;
        margin: 0 -70px 0 50px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: 0 -50px 0 50px;
        }
      }
      &.width {
        height: 15px;
        width: 125px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 100px;
        }
      }
      &.profile {
        border-radius: 100%;
        border: 2px solid #e9e9e9;
      }
      &.checkbox {
        margin-top: 20px;
      }
      &.redius-1 {
        border-radius: 8px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
  }
`;
